import React, { useEffect, useState } from "react";
import CurriculumFramework from "./CurriculumFramework";
import { useTranslation } from "react-i18next";
import Util from "../../Util";
import { getUpdatedSchool } from "../../components/CommonApis";
import Loader from "../../components/common/Loader";

const SuperAdminTemplate = () => {
  const { t } = useTranslation();
  const school = Util.getSelectedSchool();
  const [schoolLoading, setSchoolLoading] = useState(true);
  const [isSchool, setIsSchool] = useState(null);

  useEffect(() => {
    async function fetchData() {
      const schooldata = await getUpdatedSchool(school.id);
      setIsSchool(schooldata);
      setSchoolLoading(false);
    }

    fetchData();
  }, [school.id]);

  if (schoolLoading) {
    return <Loader />;
  }

  if (!isSchool?.progress_tracking) {
    return (
      <div
        className="d-flex justify-content-center"
        style={{
          fontWeight: "bold",
          fontSize: "20px",
          color: "#ed3131",
          alignItems: "center",
          height: "500px",
        }}
      >
        Module Access Denied
      </div>
    );
  }

  return (
    <div
      onClick={() => {
        document.body.classList.remove("offcanvas-active");
      }}
    >
      <div className="container-fluid">
        <div className="body">
          <div className="col-lg col-md-12 p-3">
            <div className="row py-3">
              <div className="col-md-4 text-start">
                <h2 className="page-head">{t("Curriculum Framework")}</h2>
              </div>
            </div>
            <div className={"table-div"}>
              <CurriculumFramework isAdmin={true} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperAdminTemplate;
